import styled from "styled-components";

export const Header = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 28px;
    
    span{
        font-size: 18px;
        color: ${props => props.theme.colors.textBold};
        font-weight: 700;
    }
`;